/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

/**
 * Controls which entities are created during sandbox data generation.
 */
export type SandboxGenerationMode = typeof SandboxGenerationMode[keyof typeof SandboxGenerationMode];


export const SandboxGenerationMode = {
  Full: 'Full',
  CandidatesOnly: 'CandidatesOnly',
  JobsOnly: 'JobsOnly',
} as const;
